import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { TagIcon } from '@gemini/icons';
import { isPlural } from '@shared-utils/helpers/lokalise';
const PropertiesForSale = ({ propertiesCount, t }) => {
    const hasProperties = propertiesCount && propertiesCount > 0;
    let placeHolder;
    if (hasProperties) {
        const plural = isPlural(propertiesCount);
        placeHolder = t(`wlac_nb_propforsale.${plural}`, { count: propertiesCount });
    }
    else {
        placeHolder = t('wlac_no_propforsale');
    }
    return (_jsxs(Box, { alignItems: "start", display: "flex", color: propertiesCount !== 0 ? 'color.content.default.default' : 'color.content.disabled', children: [_jsx(TagIcon, { marginRight: "spacing.4", size: "sizing.16" }), _jsx(Box, { as: "span", typography: "typography.body.14.regular", children: placeHolder })] }));
};
export default PropertiesForSale;
